import React from "react";
import { Decoration_Type } from "./../../ricos-schema/legacy/wix/rich_content/v1/index.js";
const decorator = (element, underlineDecoration) => {
  const { underlineData } = underlineDecoration;
  const isUnderline = typeof underlineData === "undefined" || underlineData;
  return /* @__PURE__ */ React.createElement("u", { key: element.key, style: { textDecoration: isUnderline ? "underline" : "none" } }, element);
};
const UnderlineDecorator = {
  rule: (node) => !!node.textData?.decorations?.some(({ type }) => type === Decoration_Type.UNDERLINE),
  decorate: ({ element, node }) => {
    const underlineDecoration = node.textData?.decorations?.find(
      ({ type }) => type === Decoration_Type.UNDERLINE
    );
    return decorator(element, underlineDecoration);
  },
  priority: 2
};
var viewer_default = UnderlineDecorator;
export {
  viewer_default as default
};
//# sourceMappingURL=viewer.js.map
